import isConsentResolved from '../isConsentResolved'

const CHECK_INTERVAL_MS = 100


export default function waitForConsent({ handleResolved, timeoutMS }) {
  if ( isConsentResolved() ) {
    handleResolved()
    return
  }

  const startedAt = Date.now()

  const intervalID = setInterval(() => {
    if ( isConsentResolved() ) {
      clearInterval(intervalID)
      handleResolved()
      return
    }

    if ( Date.now() - startedAt >= timeoutMS ) {
      clearInterval(intervalID)
    }
  }, CHECK_INTERVAL_MS)
}
